const questionsListDOM = document.querySelector('dl.question-list')

const questionTitleDOMs = questionsListDOM.querySelectorAll('dt')

Array.prototype.forEach.call(questionTitleDOMs, (titleDOM) => {
  const descriptionDOM = titleDOM.nextElementSibling
  let isOpen = false

  titleDOM.addEventListener('click', () => {
    const contentHeight = descriptionDOM.querySelector('.wrapper').offsetHeight;
    isOpen = !isOpen

    if (isOpen) {
      titleDOM.classList.add('open')
      descriptionDOM.style.height = `${contentHeight}px`
    } else {
      titleDOM.classList.remove('open')
      descriptionDOM.style.height = '0'
    }
  })
})
